import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-new-file",
  "use": "svgIcon-new-file-usage",
  "viewBox": "0 0 292.842 292.842",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 292.842 292.842\" id=\"svgIcon-new-file\"><path d=\"M243 75h-58V17l29 28.6z\" fill=\"currentColor\" /><path d=\"M32.7 293V0h128v88c0 6.8 5.5 12.3 12.3 12.3h88v193H33\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol